import React from 'react';
import PropTypes from 'prop-types';
import FormattedText from '../../../01_atoms/FormattedText';
import PhoneIcon from '../../../../public/static/icons/phone-2024.svg';
import {
  behaviorSettingsProps,
  generateClassNameByBehaviorSettings,
} from '../../../../utils/behaviorSettings';

import styles from './index.module.scss';

const BBOfflineDonation = ({
  title = 'Other ways to donate',
  files = [],
  descriptionPost = '',
  descriptionPhone = '',
  bottomDescriptionPhone = '',
  phoneNumbers = [],
  behaviorSettings = null,
  uuid = null,
}) => (
  <div
    className={`bb bb-offline-donation ${
      styles['bb-offline-donation']
    } ${generateClassNameByBehaviorSettings(behaviorSettings)}`}
    id={uuid}
  >
    <div className="container">
      <div className={styles['wrapper']}>
        {!!title && <h3>{title}</h3>}
        <div className={styles['donate-options']}>
          {!!files.length && (
            <div className={styles['donate-option']}>
              <div className={styles['title']}>Donate by Post</div>
              <FormattedText text={descriptionPost} className={styles['description']} />
              <div className={styles['files']}>
                {files.map((file) => (
                  <a
                    href={file.downloadURL}
                    key={file.title}
                    className={styles['file']}
                    target="_blank"
                    rel="noreferrer"
                    data-analytics={`offline-${file.title
                      .split(' ')
                      .join('-')
                      .toLowerCase()}-download`}
                  >
                    <div className={styles['file-title']}>{file.title}</div>
                    {!!file.type && `(${file.type})`}
                    <div className={styles['tab-icon']} aria-label="Opens a new window" />
                  </a>
                ))}
              </div>
            </div>
          )}
          <div className={styles['donate-option']}>
            <div className={styles['title']}>Donate by Phone</div>
            <FormattedText text={descriptionPhone} className={styles['description']} />
            <div className={styles['phone-numbers']}>
              {!!phoneNumbers.length &&
                phoneNumbers.map((phoneNumber) => (
                  <div className={styles['phone-number']} key={phoneNumber.number}>
                    <PhoneIcon />
                    <a
                      href={`tel:${phoneNumber.number}`}
                      aria-label={phoneNumber.ariaLabel}
                      data-analytics="offline-donation-phone-number"
                    >
                      {phoneNumber.formatted}
                    </a>
                  </div>
                ))}
            </div>
            <FormattedText text={bottomDescriptionPhone} className={styles['description']} />
          </div>
        </div>
      </div>
    </div>
  </div>
);

BBOfflineDonation.propTypes = {
  title: PropTypes.string.isRequired,
  files: PropTypes.arrayOf(
    PropTypes.shape({
      downloadURL: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      type: PropTypes.string,
    }),
  ),
  phoneNumbers: PropTypes.arrayOf(
    PropTypes.shape({
      number: PropTypes.string.isRequired,
      formatted: PropTypes.string.isRequired,
    }),
  ),
  descriptionPost: PropTypes.string,
  descriptionPhone: PropTypes.string,
  bottomDescriptionPhone: PropTypes.string,
  behaviorSettings: behaviorSettingsProps,
  uuid: PropTypes.string,
};

export default BBOfflineDonation;
